module.exports = require("../../version/RundeckVersionDisplay.vue");